<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-graduation-cap'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption">
        <span class="font-weight-bold">{{ printRank }}：</span>{{ printDept }}
      </v-list-item-subtitle>
      <v-list-item-title>{{ printName }}</v-list-item-title>
      <v-list-item-subtitle class="caption"><span class="font-weight-bold">{{ printStatus }}：</span>{{ printDate }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading || isLoading">
            <v-icon small>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>編集する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-combobox
          v-model="form.rank"
          label="学位"
          :rules="rules.rank"
          :items="getRankItems"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="form.name"
          label="学校名"
          :rules="rules.name"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="form.dept"
          label="学部・学科名"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-radio-group required row
          v-model="form.status"
          label="在籍状況"
          :rules="rules.status">
          <v-radio v-for="(item, key) in getStatusItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="12" class="px-3">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.date"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field readonly required
              v-model="printFormatedDate"
              v-on="on"
              :rules="rules.date"
              label="卒業・中退日"
            />
          </template>
          <v-date-picker
            v-model="form.date"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.date = false"
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsCareer',
  components: {
    UtilConfirmModal,
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'career',
        status: {
          loading: false
        },
        datepicker: {
          date: false
        }
      },
      meta: {
        ranks: [
          '中学校',
          '高校',
          '高専',
          '専門学校',
          '短大',
          '大学',
          '大学院',
          '博士'
        ]
      },
      form: {
        id: '',
        name: '',
        rank: '',
        dept: '',
        status: '',
        date: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        rank: [
          v => !!v || '必須項目です'
        ],
        status: [
          v => !!v || '必須項目です'
        ],
        date: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          name: dt.name ? dt.name : '',
          rank: dt.rank ? dt.rank : '',
          dept: dt.dept ? dt.dept : '',
          status: dt.status ? dt.status : '',
          date: dt.date ? dt.date : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          name: this.$props.data.name ? this.$props.data.name : '',
          rank: this.$props.data.rank ? this.$props.data.rank : '',
          dept: this.$props.data.dept ? this.$props.data.dept : '',
          status: this.$props.data.status ? this.$props.data.status : '',
          date: this.$props.data.date ? this.$props.data.date : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('career_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '学歴の削除',
        message: 'この学歴を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'about/delete/meta', {
              id: this.$props.data.id,
              cid: this.$route.params.id
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'remove',
                  data: {
                    type: 'careers',
                    id: res.data.data.id ? res.data.data.id : ''
                  }
                })
              }
            })
          })
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('career_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('career_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('career_' + this.$props.data.id)
      )
    },
    printRank () {
      return (
        this.$props.data &&
        this.$props.data.rank
      ) ? this.$props.data.rank : ''
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name
      ) ? this.$props.data.name : '学歴'
    },
    printDept () {
      return (
        this.$props.data &&
        this.$props.data.dept
      ) ? this.$props.data.dept : ''
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$mango.about.career.status[this.$props.data.status]
      ) ? this.$mango.about.career.status[this.$props.data.status] : ''
    },
    printDate () {
      return (
        this.$props.data &&
        this.$props.data.date
      ) ? this.$moment(this.$props.data.date).format('YYYY/MM/DD') : ''
    },
    printFormatedDate () {
      return (
        this.form &&
        this.form.date
      ) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    },
    getRankItems () {
      return this.meta.ranks
    },
    getStatusItems () {
      return this.$mango.about.career.status
    }
  }
}
</script>
